import type { JSX } from 'react';
import { getSizeInPx } from 'stylesheet';

import { SvgIcon } from './SvgIcon';
import { IconProps } from './types';

export const LogOutIcon = ({ widthInPx, heightInPx, color }: IconProps): JSX.Element => (
  <SvgIcon
    viewBox="0 0 24 24"
    style={{
      width: getSizeInPx(widthInPx ?? 20),
      height: getSizeInPx(heightInPx ?? 20),
    }}
  >
    <g transform="scale(-1,1) translate(-24,0)">
      <path
        d="M16 13v-2H8V8l-5 4 5 4v-3h8zm3-11H5c-1.1 0-2 .9-2 2v4h2V4h14v16H5v-4H3v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
        fill={color ?? 'currentColor'}
      />
    </g>
  </SvgIcon>
);
